/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 7:45 AM
 *
 */

import toast from 'react-hot-toast';
import axios, { AxiosResponse } from 'axios';
import { store } from 'stores';

import { removeAuth, setToken } from 'features/auth';

const baseURL = process.env.REACT_APP_API_URL ?? 'https://staging-api2.sunya.health/api/v1/';

export const privateAgent = axios.create({
  baseURL,
});

privateAgent.interceptors.request.use(
  (config) => {
    const token = store.getState().auth.token;
    if (token && config.headers) {
      config.headers['Authorization'] = `${token}`;
      config.headers['Access-Control-Allow-Origin'] = '*';
    }
    return config;
  },
  () => {
    store.dispatch(removeAuth());
    if (process.env.REACT_APP_ENVIRONMENT === 'DEVELOPMENT') {
      window.open('https://dev.app.sunya.health');
    } else {
      window.open('https://app.sunya.health');
    }
    // TODO(Need to switch to production)

    toast.error('Credentials Has Expired! Please Log In Again!!', {
      id: 'credentials-error',
    });
  }
);

privateAgent.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    const originalRequest = error.config;
    const token = store.getState().auth.token;
    if (token && error?.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const axiosConfig = {
        headers: {
          Authorization: token,
        },
      };
      return axios
        .post(`${baseURL}auth/refresh/`, null, axiosConfig)
        .then((res: AxiosResponse) => {
          if (res.status === 200) {
            const tokenData = res.data.data;
            store.dispatch(setToken(tokenData));
            return privateAgent(originalRequest);
          }
        })
        .catch(() => {
          store.dispatch(removeAuth());
          // TODO(Need to switch to production)
          if (process.env.environment === 'DEVELOPMENT') {
            window.open('https://dev.app.sunya.health');
          } else {
            window.open('https://app.sunya.health');
          }

          toast.error('Credentials Has Expired! Please Log In Again!!', {
            id: 'log-out-toast',
          });
        });
    }
    return Promise.reject(error);
  }
);
